"use strict";


const baseURL = "https://andrew-dev.pericode.in";
// const baseURL = "https://andrew-web.pericode.in";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.baseURL = baseURL; 
